import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl';
import useCurrentUser from 'hooks/useCurrentUser'
import { useHistory } from 'react-router-dom'

const ReleasedNotDownloadedTasksWidget = ({widget}) => {
  const mounted = useRef(false);
  const history = useHistory()

  const { features = [], roles = [] } = useCurrentUser()
  
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch('coordinatordashboard/Released_Not_Downloaded_Tasks')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setTasks(data.data.tasks);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const track = () => {
    const body = new FormData()
    body.append('key', 'voicearchive.system.feature.ui.coordinatordashboard.releasedNotDownloadedTasks')
    body.append('type', 'increment')
    fetch(`/system/stats`, { method: 'POST', body })
  }

  const getDeadline = (task) => {
    const value = new Date(task["deadline"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const orderDetails = (uid) => {
      return history.push(`/task/${uid}`)
  };
  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <table className="w-full table-fixed text-xs" onClick={track}>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.uid} className="hover:bg-gray-200" title={task['message']} >
              <td className="border-b w-1/12 px-4 py-2">
                {task["shortname"]}
              </td>
              <td
                className="border-b w-8/12 px-4 py-2 cursor-pointer hover:text-primary"
                onClick={() => orderDetails(task.uid, task["orderid"])}
              >
                {task["title"]}
              </td>

              <td className="border-b w-3/12 px-4 py-2">
                {getDeadline(task)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </li>
  );

}

export default ReleasedNotDownloadedTasksWidget;
